import StatusErrorPage from './StatusErrorPage';

export default StatusErrorPage;
